import{useSelector}from'react-redux';export var useAppSelector=useSelector;